module.exports = __webpack_public_path__ + "static/media/creative-commons-zero.e34d0d9b.svg";